'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withInputSelect = exports.isInputSelect = undefined;

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    position: absolute;\n\n    top: -33px;\n    right: 6px;\n\n    label, label > span {\n        white-space: nowrap;\n        margin-right: 0px;\n    }\n'], ['\n    position: absolute;\n\n    top: -33px;\n    right: 6px;\n\n    label, label > span {\n        white-space: nowrap;\n        margin-right: 0px;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _Radio = require('./Radio');

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var withInputFunctions = {
    workplace_company: 'workplace_company'
};

var AdditionalControl = _styledComponents2.default.div(_templateObject);

var InputSelect = function InputSelect(props) {
    var fromDB = ((0, _path3.default)(['input', 'value', 'type'], props) || (0, _path3.default)(['input', 'type'], props)) === 'dropdown';

    var setFromDBHandle = function setFromDBHandle() {
        var type = !fromDB;
        props.input.onChange(_extends({}, props.input.value, {
            type: type ? 'dropdown' : 'input',
            value: undefined
        }));
    };

    var additional = _react2.default.createElement(
        'div',
        { style: { position: 'relative' } },
        _react2.default.createElement(
            AdditionalControl,
            null,
            _react2.default.createElement(
                _Radio.Radio.Label,
                null,
                _react2.default.createElement(_Radio.Radio, {
                    onChange: setFromDBHandle,
                    checked: fromDB,
                    disabled: props.disabled }),
                _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'selectInput' })
            )
        )
    );

    return fromDB ? _react2.default.createElement(_Select2.default, _extends({}, props, { additional: additional, type: fromDB ? 'dropdown' : 'input' })) : _react2.default.createElement(_Input2.default, _extends({}, props, { additional: additional, type: fromDB ? 'dropdown' : 'input' }));
};

InputSelect.propTypes = {
    input: _propTypes2.default.object,
    disabled: _propTypes2.default.bool
};

var isInputSelect = exports.isInputSelect = function isInputSelect(fn) {
    return withInputFunctions[fn];
};

var withInputSelect = exports.withInputSelect = function withInputSelect(SelectWrapped) {
    return function (props) {
        return isInputSelect((0, _path3.default)(['item', 'function'], props)) ? _react2.default.createElement(InputSelect, props) : _react2.default.createElement(SelectWrapped, props);
    };
};